/* eslint-disable no-dupe-else-if */
import classnames from 'classnames/bind'
import type { ReactNode } from 'react'

// Components
import WebHeader from './components/WebHeader'
// import Footer from './components/Footer'

// Constants
import { ROUTE_PATH } from '@/constants/routePath'

// Styles
import styles from './style.module.scss'

// Variables
const cx = classnames.bind(styles)

type LiveLayoutProps = {
  children: ReactNode
  isFlutterApp?: boolean
  pathname: string
}

const fullHeightPages: Set<keyof typeof ROUTE_PATH> = new Set([ROUTE_PATH.LIVE_ROOM])

const LiveMallLayout = (props: LiveLayoutProps) => {
  const { children, isFlutterApp, pathname } = props
  const isLandingPage = pathname === ROUTE_PATH.LANDING_PAGE
  // 直播間無法塞 TutorFlutter，直接排除
  const isLiveRoomProduct = pathname === ROUTE_PATH.LIVE_ROOM_PRODUCT
  const isFullHeightPage = fullHeightPages.has(pathname as keyof typeof ROUTE_PATH)
  const isAboutPage = pathname.startsWith(ROUTE_PATH.ABOUT)

  const isShowHeader = () => {
    if (isFlutterApp) return false
    return !isLandingPage && !isLiveRoomProduct && !isAboutPage
  }

  return (
    <div id='layout' className={cx('layout', { 'layout--no-header-footer': !isShowHeader() })}>
      {isShowHeader() && <WebHeader />}

      <div className={cx('layout-body', { 'layout-body--full-height': isFullHeightPage })}>{children}</div>
      {/* <Footer /> */}
    </div>
  )
}

export default LiveMallLayout
